import { render, staticRenderFns } from "./imagebox.vue?vue&type=template&id=f7ef4222&scoped=true"
import script from "./imagebox.vue?vue&type=script&lang=js"
export * from "./imagebox.vue?vue&type=script&lang=js"
import style0 from "./imagebox.vue?vue&type=style&index=0&id=f7ef4222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ef4222",
  null
  
)

export default component.exports